"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdsButtons_1 = require("../sdsButtons");
const SecondaryButton_module_css_1 = __importDefault(require("./SecondaryButton.module.css"));
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line jsdoc/require-jsdoc
function SecondaryButton(props) {
    return (0, jsx_runtime_1.jsx)(sdsButtons_1.ButtonOrLink, { ...props, className: SecondaryButton_module_css_1.default.secondaryButton });
}
exports.SecondaryButton = SecondaryButton;
//# sourceMappingURL=SecondaryButton.js.map